import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

import { loggedIn } from '@src/lib/auth';

import { ComponentType } from 'react';
import { RouteComponentProps } from 'react-router-dom';

type UnauthedRouteProps = RouteProps & {
  component: ComponentType<any>;
  redirectTo?: string;
};

export function UnauthedRoute(props: UnauthedRouteProps) {
  const { component: Component, redirectTo, ...rest } = props;

  return (
    <Route
      {...rest}
      render={(props: RouteComponentProps) => {
        if (!loggedIn()) {
          return <Component {...props} />;
        }

        return <Redirect to={redirectTo || '/'} />;
      }}
    />
  );
}

export default UnauthedRoute;
